import { createSelector, createStructuredSelector } from "reselect";

export const siteDataSelector = createSelector(
  state => state.siteData.getIn(["siteData"]),
  x =>
    x
      .toJS()
      .reduce((obj, item) => Object.assign(obj, { [item.name]: item }), {})
);

export default createStructuredSelector({
  siteData: siteDataSelector
});
